import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-manage-tags',
  templateUrl: './manage-tags.component.html',
  styleUrls: ['./manage-tags.component.scss']
})
export class ManageTagsComponent implements OnInit {

  
  getAllTagsVm = {
    databaseID: 0,
    organizationId: 0,
    PageIndex: 0,
    PageSize: 10,
    tagName: '',
    fieldID: 0,
    OfficeIDList:[],
    officeID:0
  };
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    tagName: '',
  };
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  responseHolder: any;
  tagListActive: any;
  typeListInactive: any;
  value = '';
  filterText: any;
  private _returnList: any;
  filteredList: any;
  totalCount: any;
  paginatorTotalLength: any;
  displayedColumns: string[] = [];
  dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;
  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;

  constructor(private loaderService: LoaderService, private toastr: ToastrService, private statusConst: StatusConstant,
     private reusableClass: ReusableClasses, private dialog: MatDialog, private settingsService: SettingService,
     private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID)
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    this.getTagList(this.pageModelData);
  }


  getTagList(pageData: any) {
    this.loaderService.show();    
    this.getAllTagsVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
    this.getAllTagsVm.organizationId = Number(this.organizationId);
    this.getAllTagsVm.fieldID = 10057;
    this.getAllTagsVm.PageIndex = pageData.pageIndex;
    this.getAllTagsVm.PageSize = pageData.pageSize;
    this.getAllTagsVm.tagName = pageData.tagName.trim();
    this.getAllTagsVm.OfficeIDList=this.OfficeIDList;
    this.getAllTagsVm.officeID=this.myOfficeID;
    this.pageIndex = pageData.pageIndex;
    this.pageSize = pageData.pageSize;
    this.settingsService.getAllTags(this.getAllTagsVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.tagListActive = this.responseHolder.data.tagNames;
          this.paginatorTotalLength = this.responseHolder.data.totalRecords;
          this.pageModelData.pageIndex = this.responseHolder.data.pageIndex;
          this.pageIndex = this.responseHolder.data.pageIndex;
          this.pageSize = pageData.pageSize;
          if(this.tagListActive.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }    
        }
        else {
          this.ShowNoRecordFound=true;
          this.tagListActive=[];
          this.paginatorTotalLength =0;
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.tagListActive=[];
        this.paginatorTotalLength =0;
        this.loaderService.hide();
      }
    });
  }



  deleteTags(tagName: any) {
    var message;
    message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        let pageData = this.pageModelData;      
        this.getAllTagsVm.databaseID = parseInt(sessionStorage.getItem('databaseId'));
        this.getAllTagsVm.organizationId = Number(this.organizationId);
        this.getAllTagsVm.fieldID = 10057;
        this.getAllTagsVm.PageIndex = pageData.pageIndex;
        this.getAllTagsVm.PageSize = pageData.pageSize;
        this.getAllTagsVm.tagName = tagName;//pageData.tagName; 
        this.getAllTagsVm.OfficeIDList=this.OfficeIDList;
        this.getAllTagsVm.officeID=this.myOfficeID;      
        this.settingsService.deleteTag(this.getAllTagsVm).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.data == 1) {
              this.toastr.success('Tag deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getTagList(this.pageModelData);
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
  }


  close() {
    this.dialog.closeAll();
  }

  Search(filterValue) {
    this.filterText = filterValue.trimLeft();
    this.pageModelData.tagName = filterValue.trim();
    this.getTagList(this.pageModelData);
  }

  clearFilter(){
    this.value = "";
    this.filterText = "";
    this.pageModelData.tagName = this.filterText.trim();
    this.getTagList(this.pageModelData);
  }

  CallNextPrevPageData(pageData: PageEvent) {
    this.currentData = pageData;
    this.pageModelData.pageIndex = pageData.pageIndex;
    this.pageModelData.pageSize = pageData.pageSize;
    this.pageModelData.tagName = this.value.trim();
    this.getTagList(this.pageModelData);
  }

}